module.exports = {
	"apertureWidth": "Szerokość apertury",
	"apertureLength": "Długość apertury",
	"apertureGap1": "Odstęp apertury 1",
	"apertureGap2": "Odstęp apertury 2",
	"ballDiameter": "Średnica kulki",
	"bodyOffset": "Odsunięcie korpusu",
	"bodyLength": "Długość korpusu",
	"bodyDiameter": "Średnica korpusu",
	"bodyHeight": "Wysokość korpusu",
	"bodyColor": "Kolor korpusu",
	"componentFamily": "Rodzina komponentów",
	"colPitch": "Podział kolumn",
	"chipArrayNote": "* L1 i b1 są opcjonalne.",
	"crystalNote": "* Wybierz opcjonalny wymiar z (D, D2, L). Różne kombinacje mogą tworzyć różne rozmiary padów footprintów.",	
	"densityLevel": "Poziom gęstości",	
	"femaleStandoffNote": "* Pad otworu montażowego jest opcjonalny i może być generowany przez wprowadzenie wartości dla wymiarów pokazanych na lewej ilustracji. Średnica otworu (b) służy do generowania otworów montażowych i dla modelu mechanicznego podkładki dystansowej bez gwintu wewnętrznego.",
	"footprintOrigin": "Początek footprintu",
	"hPinPitch": "Raster pinów w poziomie",
	"hTerminalGap": "Odstęp przyłączy w poziomie",
	"hTerminalTailLength": "Długość końca przyłącza w poziomie",
	"innerThreadDepth": "Głębokość gwintu wewnętrznego",
	"innerThreadSize": "Rozmiar gwintu wewnętrznego",
	"innerThreadDesignation": "Oznaczenie gwintu wewnętrznego",
	"leadDiameter": "Średnica wyprowadzenia",
	"leadSpan": "Rozpiętość wyprowadzeń",
	"leadSpan1": "Rozpiętość wyprowadzeń 1",
	"leadSpan2": "Rozpiętość wyprowadzeń 2",
	"leadShape": "Kształt wyprowadzenia",
	"largerTerminalLength": "Większa długość przyłącza",
	"largerTerminalWidth": "Większa szerokość przyłącza",
	"maleFemaleStandoffNote": "* Pad otworu montażowego jest opcjonalny i może być generowany przez wprowadzenie wartości dla wymiarów pokazanych na lewym rysunku. Średnica otworu (b) służy do generowania otworu montażowego.",
	"mapSilkscreen": "Mapowanie opisu na korpus",
	"optionalDimensionNote": "* Wybierz opcjonalny wymiar z (D, D2, L). Różne kombinacje mogą tworzyć różne rozmiary padów footprintów.",
	"oddTerminalLength": "Długość nieparzystego przyłącza",
	"oddTerminalWidth": "Szerokość nieparzystego przyłącza",
	"optionalDimension": "Wymiar opcjonalny",	
	"partialThread": "Gwint częściowy",	
	"pasteCoverage": "Pokrycie pastą",
	"producibilityLevel": "Poziom standardu produkcji",
	"pinPitch": "Raster pinów",
	"padToHoleRatio": "Stosunek wielkosci padu do wielkosci otworu",
	"padRoundness": "Zaokrąglenie padu",
	"pinNumbering": "Numerowanie pinów",
	"postLength": "Długość słupka",
	"postThreadSize": "Rozmiar gwintu słupka",
	"postThreadDesignation": "Oznaczenie gwintu słupka",
	"rowPitch": "Podział wierszy",
	"tabWidth": "Szerokość mostka",
	"tabLength": "Długość mostka",
	"terminalThickness": "Grubość przyłącza",
	"terminalWidth": "Szerokość przyłącza",
	"terminalLength": "Długość przyłącza",
	"terminalGap": "Odstęp przyłączy",
	"terminalCCGap": "Odstęp między środkami przyłączy",
	"terminalCCGap1": "Odstęp między środkami przyłączy 1",
	"terminalCCGap2": "Odstęp między środkami przyłączy 2",
	"terminalTailLength": "Długość końca przyłącza",
	"terminalPostLength": "Długość słupka przyłącza",
	"terminalType": "Typ przyłącza",	
	"threadDepth": "Głębokość gwintu",
	"threadSize": "Rozmiar gwintu",
	"threadDesignation": "Oznaczenie gwintu",	
	"threaded": "Gwintowany",
	"truncateMiddlePin": "Obcinanie pinu środkowego",		
	"vPinPitch": "Raster pinów w pionie",
	"vTerminalGap": "Odstęp przyłączy w pionie",
	"vTerminalTailLength": "Długość końca przyłącza w pionie",
	"#Rows": "Liczba wierszy",
	"#Cols": "Liczba kolumn",
	"#Pins": "Liczba pinów",
	"#DPins": "Liczba pinów (strona D)",
	"#EPins": "Liczba pinów (strona E)",
	"padShape": "Kształt padu",
	"RESISTOR": "Rezystor",
	"NONPOLARIZED_CAPACITOR": "Kondensator niespolaryzowany",
	"POLARIZED_CAPACITOR": "Kondensator spolaryzowany",
	"DIODE": "Dioda",
	"FUSE": "Bezpiecznik",
	"INDUCTOR": "Cewka",
	"POLARIZED_INDUCTOR": "Cewka spolaryzowana",
	"NONPOLARIZED_INDUCTOR": "Cewka niespolaryzowana",
	"LRCCW": "Przeciwnie do ruchu wskazówek zegara od dołu z lewej",
	"LRCW": "Zgodnie z ruchem wskazówek zegara od góry z lewej",
	"ZZBT": "Zygzak od dołu z lewej",
	"PIN_ONE": "Pin 1",
	"CENTER_PADS": "Środek padów",
	"female": "Żeński",
	"male": "Męski",
	"maleFemale": "Męski-żeński",
	"ROUND": "Okrągły",
	"HEX": "Sześciokątny",
	"SQUARE": "Kwadratowy",
	"Round": "Okrągły",
	"Square": "Kwadratowy",
	"RoundedSquare": "Zaokrąglony kwadratowy",
	"Rectangle": "Prostokątny",
	"Black": "Czarny",
	"Green": "Zielony",
	"Blue": "Niebieski",
	"Yellow": "Żółty",
	"Amber": "Bursztynowy",
	"Brown": "Brązowy",
	"Cyan": "Błękitny",
	"Maroon": "Bordowy",
	"Grey": "Szary",
	"Silver": "Srebrny",
	"Purple": "Purpurowy",
	"Red": "Czerwony",
	"White": "Biały",
	"Most (A)": "Największy (A)",
	"Nominal (B)": "Nominalny (B)",
	"Least (C)": "Najmniejszy (C)",
	"Most (M)": "Największy (M)",
	"Nominal (N)": "Nominalny (N)",
	"Least (L)": "Najmniejszy (L)",
	"IC": "Układ scalony (IC)",
	"PRECISION_INDUCTOR": "Cewka precyzyjna",
	"LED": "Dioda LED",
	"THERMISTOR": "Termistor",
	"POLARIZED_DIODE": "Dioda",
	"VARISTOR": "Warystor",
	"FERRITE_BEAD": "Koralik ferrytowy",
	"SOIC_SOP": "SOIC, SOP",
	"QFP": "QFP",
	"CFP": "CFP",
	"CQFP": "CQFP",
	"QFN": "QFN",
	"SOT23": "SOT23",
	"SOTFL": "SOTFL",
	"SOT223": "SOT223",
	"TO_DPAK": "TO, DPAK",
	"SOT143": "SOT143",
	"CHIP": "Chip",
	"SOD": "SOD",
	"MOLDED_BODY": "Korpus formowany",
	"SODFL": "SODFL",
	"DFN_2": "DFN-2",
	"DFN_3": "DFN-3",
	"DFN_4": "DFN-4",
	"ECAP": "Elektrolit",
	"CRYSTAL": "Rezonator kwarcowy",
	"BGA": "BGA",
	"MELF": "MELF",
	"CHIP_ARRAY_TWO_SIDE_FLAT_CONCAVE": "Macierz chipu, 2-stronna płaska/wklęsła",
	"CHIP_ARRAY_FOUR_SIDE_FLAT_CONCAVE": "Macierz chipu, 4-stronna płaska/wklęsła",
	"CHIP_ARRAY_TWO_SIDE_CONVEX": "Macierz chipu, 2-stronna wklęsła",
	"PLCC": "PLCC",
	"OSCILLATOR_CORNER_CONCAVE": "Oscylator narożnikowy wklęsły",
	"OSCILLATOR_J_LEAD": "Oscylator J-Lead",
	"OSCILLATOR_L_BEND": "Oscylator L-Bend",
	"SOJ": "SOJ",
	"AXIAL": "Osiowa",
	"DIP": "DIP",
	"PIN_HEADER_STRAIGHT": "Listwa złącza szpilkowego (męskiego) prosta",
	"PIN_HEADER_RA": "Listwa złącza szpilkowego (męskiego) z kątem prostym",
	"RECEPTACLE_HEADER_STRAIGHT": "Listwa gniazda szpilkowego (żeńskiego) prosta",
	"RECEPTACLE_HEADER_RA": "Listwa gniazda szpilkowego (żeńskiego) z kątem prostym",
	"SON_DFN": "SON (DFN)",
	"RADIAL_GENERIC": "Promieniowa ogólna (okrągła)",
	"RADIAL_LED": "Dioda LED promieniowa (okrągła)",
	"CRYSTAL_HC49": "Rezonator kwarcowy (HC49)",
	"FEMALE_STANDOFF": "Odstęp dystansowy / podkładka dystansowa żeńska",
	"MALE_FEMALE_STANDOFF": "Odstęp dystansowy męsko-żeński",
	"SNAP_LOCK": "Wspornik zatrzaskowy",
	"Optional_D": "D (rozpiętość wyprowadzeń)",
	"Optional_D2": "D2 (odstęp przyłączy)",
	"Optional_L": "L (długość przyłącza)",
	"CONCAVE": "Wklęsłe",
	"FLAT": "Płaskie",
	"Oblong": "Podłużne",
	"Collapsing_Ball": "Zapadająca się kulka",
	"Non_Collapsing_Ball": "Niezapadająca się kulka",
	"mountingHolePad": "Pad otworu montażowego",
	"withVias": "Z przelotkami",
	"viasCount": "Liczba przelotek",
	"viaDiameter": "Średnica przelotki",
	"viaOffset": "Odsunięcie przelotki od środka otworu",
	"viaThermalRelief": "Odstęp termiczny przelotki",
	"radialLedNote": "* c nie jest stosowane w przypadku zaokrąglonego kształtu wyprowadzenia.",
	"lockHeight": "Wysokość zatrzasku",
	"overrideLockDiameter": "Zastąp średnicę zatrzasku",
	"lockDiameter": "Średnica zatrzasku",
	"overridePitch": "Zastąp raster pinów",
	"bodyWidth": "Szerokość korpusu",
	"padWidth": "Szerokość padu",
	"plated": "Powlekany",
	"ViaOffset": "Odsunięcie przelotki od środka otworu",
	"holeDiameter": "Średnica otworu",
	"snapLockNote1": "* Średnica zatrzasku (E1) jest obliczana automatycznie na podstawie średnicy korpusu (E) i średnicy otworu (b). Można jednak podać wartość niestandardową, zastępując średnicę zatrzasku.",
	"snapLockNote2": "* Średnica otworu (b) nie powinna być równa średnicy korpusu (E) ani średnicy zatrzasku (E1)",
	"leadWidth": "Szerokość wyprowadzenia",
	"leadThickness": "Grubość wyprowadzenia",
	"boardThickness": "Grubość płytki",
	"error1": "Nie zaimplementowano.",
	"fabricationTolerance": "Tolerancja produkcyjna", 
	"placementTolerance": "Tolerancja umieszczenia",
	"CAPACITOR": "Kondensator niespolaryzowany",
	"CAPACITOR_NONPOLARIZED": "Kondensator niespolaryzowany",
	"CAPACITOR_NON_POLARIZED": "Kondensator niespolaryzowany",
	"FILTER": "Filtr", 
	"TRANSISTOR": "Tranzystor",
	"ecapNote": "* Wybierz opcjonalny wymiar z (D, D2, L). Różne kombinacje mogą tworzyć różne rozmiary padów footprintów.",
	"maximum": "Maks.", 
	"nominal": "Nominalna", 
	"minimum": "Min.",
	"bodyShape": "Kształt korpusu",
	"customSolderPaste": "Niestandardowa pasta lutownicza",
	"thermalPad": "Pad termiczny",
	"thermalPadLength": "Długość padu termicznego",
	"thermalPadWidth": "Szerokość padu termicznego",
	"RoundedRectangle": "Prostokątny zaokrąglony",
	"extendedEdgeLength": "Długość wydłużonej krawędzi",
	"Generator": " Generator",
	"axialNote": "* Raster pinów jest automatycznie obliczany na podstawie rozmiaru korpusu, przyłącza i poziomu standardu produkcji, aby zapewnić zgodność footprintu ze standardem IPC. Można jednak podać wartość niestandardową, zastępując raster pinów w celu utworzenia footprintu niezgodnego ze standardem IPC.",
	"baseHeight": "Wysokość podstawy",
	"CHIP_LED": "Chip LED",
	"updatePreview": "Aktualizuj podgląd",
	"Custom": "Niestandardowy",
	"ledColorNote": "* W przypadku niestandardowego koloru korpusu wprowadź jego wartość szesnastkową.",
	"customBodyColor": "Niestandardowy kolor korpusu",							
	"lensShape": "Kształt soczewki",
	"domeDiameter": "Średnica kopuły",
	"RECT_FLAT_TOP": "Prostokąt z płaską górą",
	"RECT_DOMED_TOP": "Prostokąt z kopułkową górą",
	'customFootprint': 'Footprint niestandardowy',
	'customPadLength': 'Niestandardowa długość padu',
	'customPadWidth': 'Niestandardowa szerokość padu',
	'customPadGap': 'Niestandardowy odstęp między padami',
	'customOddPadWidth': 'Niestandardowa szerokość padu nieparzystego',
	'customOddPadLength': 'Niestandardowa długość padu nieparzystego',
	'customPadDiameter': 'Niestandardowa średnica padu',
	'customPadSpan1': 'Niestandardowa rozpiętość padów 1',
	'customPadSpan2' : 'Niestandardowa rozpiętość padów 2',
	'customPadPitch' : 'Niestandardowy raster padów',
	'pinPitch1' : 'Raster pinów 1',
	'customPadGap1': 'Niestandardowy odstęp między padami 1',
	'Optional_g': 'g (niestandardowy odstęp padów)',
	'Optional_p': 'p (niestandardowy raster padów)',

	// JS Widgets
	"New_Library": "Nowa biblioteka",
	"Components": "Komponenty",
	"Component": "Komponent",
	"Symbols": "Symbole",
	"Symbol": "Symbol",
	"Footprints": "Footprinty",
	"Footprint": "Footprint",
	"Packages": "Obudowy",
	"Package": "Obudowa",
	"No": "Nr",
	"Name": "Nazwa",
	"Pins": "Piny",
	"Pads": "Pady",
	"Description": "Opis",
	"Variants": "Warianty",
	"Type": "Typ",
	"Hub_URN": "Hub URN",
	"Hub_Version": "Hub Version",
	"Library_io_URN": "Nazwa URN Library.io",
	"Library_io_Version": "Wersja Library.io",
	"Link": "Połącz",
	"Rename": 'Zmień nazwę',
	"Edit_Description": 'Edytuj opis',
	"Duplicate": 'Duplikuj', // verb, not noun.  ie "Make a copy"
	"Create_New_3D_Model": 'Utwórz nowy model 3D',
	"Attach_Copy_Existing_3D_Model": 'Dołącz kopię istniejącego modelu 3D',
	"Edit": 'Edycja',
	"Delete": 'Usuń',
	"Remove_From": 'Usuń z',
	"Update_To_Latest": 'Aktualizuj do najnowszego',
	"Create_New_Symbol": 'Utwórz nowy symbol',
	"Create_New_Footprint": 'Utwórz nowy footprint',
	"Create_New_Component": 'Utwórz nowy komponent',
	"Create_New_Package": 'Utwórz nową obudowę',
	"Delete_Package_Children_Warning": "Spowoduje to również usunięcie obudów używanych przez ten footprint.",
	"No_Search_Results": "Brak wyników wyszukiwania",
	"No_Library_Loaded": "Biblioteka niewczytana",
	"Library_Stored_Fusion_Hub": "Ta biblioteka jest przechowywana w usłudze your Fusion Hub.",
	"Library_Linked_Managed_Library": "Ta biblioteka jest połączona z biblioteką zarządzaną Library.io.",
	"Library_Local_Changes": "Ta biblioteka zawiera zmiany, które nie zostały wysłane do Library.io. Aby to zrobić, przejdź do paska narzędzi 'Zarządzaj'.",
	"Library_Remote_Changes": "Ta biblioteka zawiera nowe aktualizacje, które można pobrać z Library.io. Aby to zrobić, przejdź do paska narzędzi 'Zarządzaj'.",
	"View_on_Library_io": "Wyświetl w Library.io",
	"Used_In": "Używane w",
	"No_Selection": "Brak wyboru",

	"No_Footprints": "Brak footprintów",
	"No_Symbols": "Brak symboli",
	"No_Components": "Brak komponentów",
	"No_Packages": "Brak obudów",

	"Package_Loading_Message": "Zaczekaj na zapisanie i przekazanie pakietu.",
	"Attributes": "Atrybuty",
	"View_Attributes": "Atrybuty widoku",
	"Edit_Attributes": "Atrybuty widoku",
	"Edit_Description": "Edytuj opis",
	
	"Use_Placeholder": "Użyj obiektu zastępczego",
	"Placeholder_Message": "Użyj obiektu zastępczego, gdy żaden model 3D nie jest skojarzony z footprintem.",

	"Hub": "Hub",
	"New_Symbol": 'Nowy symbol',
	"New_Footprint": 'Nowy footprint',
	"New_Component": 'Nowy komponent',
	"New_Package": 'Nowa obudowa',

	"Asset_Ahead":  "Local changes are detected.  To publish these changes to Library.io, use the 'Manage' toolbar.",
	"Package_Behind_Lio": "Aktualizacja obudowy Library.io jest dostępna. Kliknij prawym przyciskiem myszy i wybierz polecenie Aktualizuj.",
	"Package_Behind_Fusion": "Aktualizacja obudowy Fusion jest dostępna. Kliknij prawym przyciskiem myszy i wybierz polecenie Aktualizuj.",
	"Package_Behind_Both": "Dostępna jest aktualizacja obudowy. Kliknij prawym przyciskiem myszy i wybierz polecenie Aktualizuj.",
	"Package_On_Lio":  "This package exists only on Library.io.  Editing it will create a linked model in your Fusion Hub.",
	"Package_Behind_Blocked": "Biblioteka musi zostać zaktualizowana, zanim będzie można wprowadzić zmiany w zasobie. Aby zaktualizować bibliotekę, użyj paska narzędzi 'Zarządzaj'.",
}